// extracted by mini-css-extract-plugin
export default {"modal":"BulkExport_modal__GrIDi","list":"BulkExport_list__u4MY8"};